import './KeepApplicationAlive.scss';
import React, { ChangeEventHandler, FormEventHandler } from 'react';
import { EmailInput } from '../form/EmailInput';
import { TokenInput } from '../form/TokenInput';

type Props = {
  email: string;
  token: string;
  hasValidEmail: boolean;
  hasValidToken: boolean;
  message: string;
  onEmailChange: ChangeEventHandler<HTMLInputElement>;
  onSubmit: FormEventHandler<HTMLFormElement>;
  onTokenChange: ChangeEventHandler<HTMLInputElement>;
  isDisabled: boolean;
};

type MessageProps = {
  message?: string;
  className?: string;
};

function Message({ message, className }: MessageProps) {
  return message && message !== '' ? (
    <div
      id="keep-alive-message"
      className={'message p-3 mt-3 mb-5 pulse ' + className}
      dangerouslySetInnerHTML={{ __html: message.replaceAll('\n', '<br />') }}
    />
  ) : (
    <div />
  );
}

export default function KeepApplicationAliveForm(props: Props) {
  const klass = (isValid: boolean) =>
    `form-control mb-2 ${isValid ? 'is-valid' : 'is-invalid'}`;
  const emailClass = klass(props.hasValidEmail);
  const tokenClass = klass(props.hasValidToken);

  return (
    <div className="card">
      <div className="card-header">
        <h3 className={'mt-2 mb-3'}>Keep your application alive</h3>
      </div>

      <div className={'card-body'}>
        <div className="row">
          <div className="col-12">
            <p>
              At this point you can keep your application for upcoming SoCraTes
              lottery draws alive.
            </p>
            <p>
              If that is what you want to do, make sure that your email address
              and the keep-alive token have been populated correctly and click
              the <i>Keep application alive</i> button. You will receive a
              confirmation mail message at the given address.
            </p>
            <p>
              In case you want to let your application expire, there is nothing
              you have to do at this point. We will remove it from the pool of
              applicants before we run the next lottery unless you actively make
              use of the option to keep it alive.
            </p>
          </div>
        </div>

        {props.message ? (
          <div>
            <Message
              message={props.message}
              className={
                'alert ' +
                (props.message.indexOf("We're sorry") > -1
                  ? 'alert-danger'
                  : 'alert-success')
              }
            />
          </div>
        ) : (
          <div>
            <form onSubmit={props.onSubmit} className="form px-3">
              <div className="row">
                <div className="col-12 mb-3">
                  <EmailInput
                    onChange={props.onEmailChange}
                    validationClass={emailClass}
                    value={props.email}
                    placeholderText={'Your email'}
                    labelText={'Email'}
                    helpText={''}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-12 mb-3">
                  <TokenInput
                    validationClass={tokenClass}
                    value={props.token}
                    onChange={props.onTokenChange}
                    minLength={32}
                    maxLength={32}
                  />
                </div>
              </div>
              <button
                id="application-keep-alive-form-button"
                className="btn btn-primary mb-3 btn-lg"
                disabled={props.isDisabled}
                type={'submit'}
              >
                Keep application alive
              </button>
            </form>
          </div>
        )}
      </div>
    </div>
  );
}
